import { fromJS, Map } from 'immutable'
import {
  SET_CREATE_ASSET_SUCCESS,
  SET_CREATE_ASSET_PROCESSING,
  SET_CREATE_ASSET_ERROR,
  SET_DELETE_ASSET_ERROR,
  SET_DELETE_ASSET_PROCESSING,
  SET_DELETE_ASSET_SUCCESS,
  SET_LIST_ASSETS_ERROR,
  SET_LIST_ASSETS_PROCESSING,
  SET_LIST_ASSETS_SUCCESS,
  RESET_CREATE_ASSET,
} from './actions'

export const initialState = Map()

export const CREATE_ASSET_KEY = 'createAsset'
export const DELETE_ASSET_KEY = 'deleteAsset'
export const LIST_ASSETS_KEY = 'listAssets'

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_CREATE_ASSET_PROCESSING:
      return state.setIn([CREATE_ASSET_KEY, 'processing'], payload.processing)
    case SET_CREATE_ASSET_SUCCESS:
      return state
        .setIn([CREATE_ASSET_KEY, 'success'], true)
        .setIn([CREATE_ASSET_KEY, 'processing'], false)
        .setIn([CREATE_ASSET_KEY, 'asset'], fromJS(payload))
    case SET_CREATE_ASSET_ERROR:
      return state
        .setIn([CREATE_ASSET_KEY, 'error'], payload.error)
        .setIn([CREATE_ASSET_KEY, 'processing'], false)
    case SET_DELETE_ASSET_PROCESSING:
      return state.setIn([DELETE_ASSET_KEY, 'processing'], payload.processing)
    case SET_DELETE_ASSET_SUCCESS:
      return state
        .setIn([DELETE_ASSET_KEY, 'success'], true)
        .setIn([DELETE_ASSET_KEY, 'processing'], false)
        .setIn([DELETE_ASSET_KEY, 'asset'], fromJS(payload))
    case SET_DELETE_ASSET_ERROR:
      return state
        .setIn([DELETE_ASSET_KEY, 'error'], payload.error)
        .setIn([DELETE_ASSET_KEY, 'processing'], false)
    case SET_LIST_ASSETS_PROCESSING:
      return state.setIn([LIST_ASSETS_KEY, 'processing'], payload.processing)
    case SET_LIST_ASSETS_SUCCESS:
      return state
        .setIn([LIST_ASSETS_KEY, 'success'], true)
        .setIn([LIST_ASSETS_KEY, 'processing'], false)
        .setIn([LIST_ASSETS_KEY, 'asset'], fromJS(payload))
    case SET_LIST_ASSETS_ERROR:
      return state
        .setIn([LIST_ASSETS_KEY, 'error'], payload.error)
        .setIn([LIST_ASSETS_KEY, 'processing'], false)
    case RESET_CREATE_ASSET:
      return state
        .deleteIn([CREATE_ASSET_KEY, 'success'])
        .deleteIn([CREATE_ASSET_KEY, 'processing'])
        .deleteIn([CREATE_ASSET_KEY, 'asset'])
    default:
      return state
  }
}
